module.exports = __webpack_public_path__ + "media/flags/ja-7244702d.svg";